module.exports = __webpack_public_path__ + "img/contact03.233051a1.png";